import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';

import { fetchPurchasePaymentRecords } from '#/api/fmsMgmt/purchasePayment';
import PurchasePaymentRecordsTable from '#/modules/srmMgmt/purchaseOrder/components/PurchasePaymentRecordsTable';
import { getRequestErrorMessage } from '#/utils/requestError';
import { purchasePaymentRecordsQueryKey } from '#/utils/queryKeys';

/**
 * 「付款計畫」頁籤下方的財務付款／退款紀錄（`accountId` 取自付款計畫 `account_id`）。
 * 呼叫端已依 `fms.purchase_payment.read` 決定是否掛載；採購權限者只看上方期別彙總。
 */
const PurchasePaymentRecordsSection = ({ accountId, phases }) => {
  const recordsQuery = useQuery({
    queryKey: purchasePaymentRecordsQueryKey(accountId),
    queryFn: () => fetchPurchasePaymentRecords(accountId),
    enabled: Boolean(accountId),
  });

  return (
    <section className="space-y-2 border-t border-gray-200 pt-4">
      <h3 className="text-sm font-medium text-gray-800">付款紀錄</h3>
      {recordsQuery.isLoading ? <p className="text-sm text-muted-foreground">讀取中…</p> : null}
      {recordsQuery.isError ? (
        <p className="text-sm text-muted-foreground">
          {getRequestErrorMessage(recordsQuery.error, '讀取付款紀錄失敗')}
        </p>
      ) : null}
      {recordsQuery.isSuccess ? (
        <PurchasePaymentRecordsTable records={recordsQuery.data?.data ?? []} phases={phases} />
      ) : null}
    </section>
  );
};

PurchasePaymentRecordsSection.propTypes = {
  accountId: PropTypes.string.isRequired,
  phases: PropTypes.arrayOf(PropTypes.object),
};

export default PurchasePaymentRecordsSection;
